import { useContext } from 'react'

import { FilterBarContext, FilterBarCtx } from 'src/components/data/providers/FilterBarProvider'

const useFilterBar = (): FilterBarCtx => useContext(FilterBarContext)

export default useFilterBar
